import { coreDefaultTheme } from '@kite-js/theme';
import { ULTheme, ULThemeBuilder } from '@theme/types';
import { coreHotelstormTheme } from './theme-hotelstorm';

const HotelstormThemeBuilder: ULThemeBuilder = (cultureCode?: string, appId?: string) => {
    const theme: ULTheme = {
        ...coreDefaultTheme,
        ...coreHotelstormTheme,
        logoUrl: '',
        background: {
            image: '',
            color: 'rgba(247, 247, 247, 1)',
            position: '0 0',
            size: 'contain',
        },
        faviconUrl: 'https://cdn6.agoda.net/images/mvc/default/favicon/hotelstorm/rocket-travel.ico',
        input: {
            ...coreDefaultTheme.input,
            borderRadius: 'S',
        },
        tab: {
            ...coreDefaultTheme.tab,
            padding: '12px 8px 12px 8px',
        },
    };

    return theme;
};

export default HotelstormThemeBuilder;
